import { Outlet, useNavigate } from "react-router-dom";
import { Euro, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APP_VERSION } from "@/lib/appMetadata";

const UserLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="user-layout-container" style={{ background: '#F5F5F5' }}>
      {/* Header */}
      <header className="header-red text-white shadow-md">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm">
              <img src="/logo.png" alt="Logo" className="w-full h-full object-contain p-1" />
            </div>
            <div>
              <h1 className="text-base sm:text-lg font-bold leading-tight">Payment Management</h1>
              <p className="text-xs sm:text-sm text-white/90">Feuerwehr Kantine</p>
            </div>
          </div>
          
          <Button
            variant="outline"
            className="border-white/30 text-white hover:bg-white/10 text-sm sm:text-base px-3 py-2"
            onClick={handleLogout}
            data-testid="user-logout-button"
          >
            <LogOut className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline">Abmelden</span>
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <div className="container mx-auto px-4 sm:px-6 py-4 sm:py-8">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-3 sm:py-4 text-center text-xs sm:text-sm text-gray-600">
        © 2025–2026 CreativeyMedia | v{APP_VERSION}
      </footer>
    </div>
  );
};

export default UserLayout;
